import { combineReducers } from 'redux'
import VehicleTypes from 'store/actionTypes/vehicle'
import { createHandleRequest } from './helpers'

const getVehicles = createHandleRequest(
  VehicleTypes.GET_VEHICLES_REQUEST,
  VehicleTypes.GET_VEHICLES_SUCCESS,
  VehicleTypes.GET_VEHICLES_FAILED
)

const getVehicleUsers = createHandleRequest(
  VehicleTypes.GET_VEHICLE_USERS_REQUEST,
  VehicleTypes.GET_VEHICLE_USERS_SUCCESS,
  VehicleTypes.GET_VEHICLE_USERS_FAILED
)

const getVehicleDetail = createHandleRequest(
  VehicleTypes.GET_VEHICLE_DETAIL_REQUEST,
  VehicleTypes.GET_VEHICLE_DETAIL_SUCCESS,
  VehicleTypes.GET_VEHICLE_DETAIL_FAILED
)

export default combineReducers({
  getVehicles,
  getVehicleUsers,
  getVehicleDetail
})
